import { connect } from 'react-redux';

import { getPriceFilter } from 'ha/pages/Search/selectors';
import PriceFilterButton, {
  Props,
} from 'ha/components/Filters/PriceFilterButton';

type MapStateToProps = Omit<Props, 'onClick'>;

export default connect<MapStateToProps>(state => ({
  priceMin: getPriceFilter(state).value.min,
  priceMax: getPriceFilter(state).value.max,
  currency: getPriceFilter(state).currency,
}))(PriceFilterButton);
